import _get from "lodash/get"

export const SSelectedBuilding = (state) => _get(state, 'navigation.selectedBuilding')
export const SIsMenuHorizontallyCollapsed = (state) => _get(state, 'navigation.isMenuHorizontallyCollapsed')
